/**
 * Części panelu włączane razem z etapami wdrożenia (docs/PLAN-WDROZENIA.md).
 * Element bez danych z API się nie pokazuje — panel nie udaje, że coś działa.
 */
export const VZ_FEATURES = {
    /** Etap 4: sprawy — Moje sprawy, baner „Twój ruch”, sprawy w toku, licznik w menu. */
    cases: true,
    /** Etap 4: zdarzenia — dzwonek, „Co ostatnio się wydarzyło”. */
    events: true,
    /** Etap 5: wyszukiwarka w pasku. */
    search: true,
} as const;
